import React, { useEffect, useState } from 'react';
import Empty from '../feedback/Empty';
import Loading from '../feedback/Loading';
import moment from 'moment';
import { GrAdd } from 'react-icons/gr';
import adminServices from '../../services/AdminServices';
import CountyModal from './CountiesModal';

function DashboardCounties() {
    const [counties, setCounties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState(0);
    const [activeCounty, setActiveCounty] = useState(null);

    useEffect(() => {
        fetchCounties();
    }, []);

    const fetchCounties = () => {
        setLoading(true);
        adminServices.getCounties()
            .then(res => {
                setCounties(res.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to fetch counties:', err);
                setLoading(false);
            });
    };

    const openModal = (actionType, county = null) => {
        setAction(actionType);
        const openBtn = document.getElementById('county-open-btn');
        if (actionType === 0) {
            openBtn?.click();
            return;
        }
        setActiveCounty(county);
        openBtn?.click();
    };

    return (
        <div className='space-y-5'>
            <div className="flex md:items-end justify-between gap-4 items-center">
                <h3 className='text-xl font-bold'>
                    Counties{' '}
                    <span className='ml-2 text-gray-500'>
                        ({counties.length})
                    </span>
                </h3>
                <button
                    onClick={() => openModal(0)}
                    className="inline-flex items-center justify-center px-4 py-2 bg-primary hover:bg-sky-600 border border-transparent rounded-lg text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary shadow-sm transition-all"
                >
                    <GrAdd className='h-5 w-5 mr-2' />
                    Add New County
                </button>
            </div>

            <CountyModal
                action={action}
                activeCounty={activeCounty}
                onReload={fetchCounties}
                setActiveCounty={setActiveCounty}
            />

            <div>
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark overflow-hidden">
                    <div className='overflow-x-auto'>
                        <table className="table table-compact table-zebra w-full">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th className='hidden md:table-cell'>Created</th>
                                    <th>Patients</th>
                                    <th>Nurses</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {counties?.length ? (
                                    counties.map((county, idx) => (
                                        <tr key={county.id || idx}>
                                            <td className='font-bold'>{county?.name}</td>
                                            <td className='hidden md:table-cell'>
                                                {county?.creation_time
                                                    ? moment(county.creation_time).format('MMM Do YYYY')
                                                    : '—'}
                                            </td>
                                            <td>
                                                {county?.patient_count}
                                            </td>
                                            <td >
                                                {county?.nurse_count}
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => openModal(1, county)}
                                                    className='btn btn-sm btn-secondary'
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : null}
                            </tbody>
                        </table>

                        {loading && <Loading />}
                        {!counties?.length && !loading && (
                            <div className="p-3">
                                <Empty objectName="Counties" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardCounties;